import { useState } from "react";
import { MagnifyingGlass, Plus } from "@phosphor-icons/react";

import { useSearch } from "@/hooks";
import { AddCourseModal } from "@/modals/Materials/AddCourseModal";
import { Button } from "@/ui";
import { tw } from "@/utils";
import { CoursesTable } from "./CoursesTable";

export const Courses = () => {
  const { searchQuery, handleSearchChange } = useSearch("");
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <div className="flex flex-col gap-y-6 pt-4">
      <div className="flex items-center justify-between gap-x-2">
        <div className="relative flex items-center justify-between">
          <div className="flex flex-row items-center">
            <div className="pointer-events-none absolute pl-3">
              <MagnifyingGlass
                size={20}
                className={tw(
                  "text-neutral-950",
                  !searchQuery && "text-neutral-500",
                )}
              />
            </div>

            <input
              type="text"
              id="search"
              placeholder="Search courses..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="block w-full rounded-xl border border-neutral-400 p-4 pl-10 text-sm text-neutral-950 placeholder:text-neutral-400 hover:ring-1 hover:ring-tertiary-600 focus:shadow-input focus:outline-none focus:ring-1 focus:ring-tertiary-600 sm:w-[456px]"
            />
          </div>
        </div>

        <Button size="md" onClick={() => setShowAddModal(true)}>
          <Plus size={20} />
          Add Course
        </Button>
      </div>

      <CoursesTable searchQuery={searchQuery} />

      <AddCourseModal
        show={showAddModal}
        onClose={() => setShowAddModal(false)}
      />
    </div>
  );
};
